import axios from "axios";
    export default axios.create({
        baseURL:"https://schoolcrud.teknij.com/school_backend/api",
        headers:{
            "Content-Type":"application/json",
            'Accept': 'application/json'
        }
    })
    